export const columns = [
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Type",
    accessorKey: "type",
    cell: ({ row }) => {
      const type = row.original.type || ""
      return type.charAt(0).toUpperCase() + type.slice(1)
    },
  },
  {
    header: "Parent",
    accessorKey: "parent_name",
    cell: ({ row }) => row.original.parent_name || "—",
  },
  {
    header: "Created At",
    accessorKey: "created_at",
  },
]
